module.exports = __webpack_public_path__ + "assets/img/00056.0eefd069.png";